import { data } from '../../svg/Location/data';
import { makeIcon } from '../makeIcon';

export const Location = makeIcon(data, 'location', 'Location');

export default Location;
